import React, { useEffect, useState } from "react";
import {
  contact1,
  contact2,
  contact3,
  contact4,
  contact5,
  contact6,
} from "../../assets/images";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import emailjs from "@emailjs/browser";

const Contact = () => {
  const { t, i18n } = useTranslation();

  const navigate = useNavigate();

  const [item, setItem] = useState([]);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [responseMessage, setResponseMessage] = useState({
    text: "",
    isError: false,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    let inputs1 = {
      name: "Ad: " + formData.name + ", Soyad: " + formData.email,
      message:
        "Ad: " +
        formData.name +
        ", Soyad: " +
        formData.email +
        ", Mesaj: " +
        formData.message,
    };

    emailjs
      .send(
        "service_nl05sdcdk",
        "template_hmcdnx9mf",
        inputs1,
        "HvyBpBCsfdcaW_2-ude"
      )
      .then(
        () => {
          console.log("SUCCESS!");
        },
        (error) => {
          console.log("FAILED...", error.text);
        }
      );

    // Form validation
    if (!formData.name || !formData.email || !formData.message) {
      setResponseMessage({
        text: "Lütfen tüm alanları doldurunuz.",
        isError: true,
      });
      return;
    }

    try {
      // Backend'inizin beklediği form-data formatında gönderim
      const formDataToSend = new FormData();
      formDataToSend.append("name", formData.name);
      formDataToSend.append("email", formData.email);
      formDataToSend.append("message", formData.message);

      const response = await axios.post(
        "https://www.elzabeauty.az/elza/contact.php",
        formDataToSend,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      // Backend yanıtını işleme
      const responseData = response.data;
      if (responseData.status === 1) {
        setResponseMessage({
          text: responseData.message || "Veri başarıyla gönderildi!",
          isError: false,
        });
        navigate(`/${currentLanguage}/contact/thank-you`);
        setTimeout(() => {
          window.scrollTo(0, 0);
        }, 100); // 100ms gecikme yeterlidir

        // Formu temizle
        setFormData({
          name: "",
          email: "",
          message: "",
        });
      } else {
        setResponseMessage({
          text: responseData.message || "İşlem başarısız oldu",
          isError: true,
        });
      }
    } catch (error) {
      console.error("API Hatası:", error);
      let errorMessage = "Sunucuya bağlanırken bir hata oluştu";

      // Sunucudan gelen hatayı işleme
      if (error.response) {
        errorMessage =
          error.response.data?.message ||
          (error.response.data
            ? JSON.stringify(error.response.data)
            : error.message);
      }

      setResponseMessage({
        text: errorMessage,
        isError: true,
      });
    }
  };

  useEffect(() => {
    getProducts();
  }, []);

  const getProducts = async () => {
    try {
      const response = await axios.get(
        `https://www.elzabeauty.az/elza/settings.php`,
        { withCredentials: false }
      );
      setItem(response.data.data[0]);
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  const currentLanguage = i18n.language; // Aktif dili alıyoruz
  const [single, setSingle] = useState(null);

  useEffect(() => {
    const getSeoTags = async () => {
      try {
        const response = await axios.get(
          "https://www.elzabeauty.az/elza/seoTagsContact.php"
        );
        const data = response.data.data || [];

        setSingle(data[0]);
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };

    getSeoTags();
  }, []);

  const getLocalizedField = (item, fieldBase) => {
    if (currentLanguage === "en")
      return item[`${fieldBase}En`] || item[fieldBase];
    if (currentLanguage === "ru")
      return item[`${fieldBase}Ru`] || item[fieldBase];
    return item[fieldBase]; // default: az
  };

  return (
    <>
      {single && (
        <Helmet>
          <title>{getLocalizedField(single, "meta_tag_title")}</title>
          <meta
            name="description"
            content={getLocalizedField(single, "meta_tag_description")}
          />
          <meta
            name="keywords"
            content={getLocalizedField(single, "meta_tag_keywords")}
          />
        </Helmet>
      )}
      <div className="mt-10 md:mt-20">
        <div className="max-w-containerSm md:max-w-container mx-auto">
          <div className="flex flex-col-reverse md:flex-row justify-between">
            <div className="md:w-[612px] mt-[32px] md:mt-0">
              <p className="text-firstColor text-[20px] md:text-[28px] font-medium">
                {t("Bizimlə Əlaqə Saxlayın")}
              </p>
              <ul className="md:space-y-6 space-y-2 mt-6 text-secondColor">
                <li className="flex">
                  <img
                    className="md:h-6 h-5 md:w-6 w-5 mr-2"
                    src={contact1}
                    alt="address"
                  />
                  <p>
                    <span>{t("Telefon")}:</span> {item.mobile}
                  </p>
                </li>
                <li className="flex">
                  <img
                    className="md:h-6 h-5 md:w-6 w-5 mr-2"
                    src={contact2}
                    alt="postal"
                  />
                  <p>
                    <span>{t("Email")}:</span> {item.email}
                  </p>
                </li>
                <li className="flex">
                  <img
                    className="md:h-6 h-5 md:w-6 w-5 mr-2"
                    src={contact3}
                    alt="phone"
                  />
                  <p>
                    <span>{t("Ünvan")}:</span> {item.location}
                  </p>
                </li>
              </ul>
              <div className="mt-6">
                <p className="text-firstColor text-[18px] font-medium">
                  {t("Sosial Şəbəkələr")}{" "}
                </p>
                <div className="flex gap-4 mt-2">
                  {[
                    { icon: contact4, url: item.whatsapp },
                    { icon: contact5, url: item.instagram },
                    { icon: contact6, url: item.tiktok },
                  ].map((social, index) => (
                    <div key={index}>
                      <a
                        target="_blank"
                        href={social.url}
                        rel="noopener noreferrer"
                      >
                        <img
                          className="w-6 h-6"
                          src={social.icon}
                          alt={`social-${index}`}
                        />
                      </a>
                    </div>
                  ))}
                </div>
              </div>
              <iframe
                className="w-full mt-10 h-[320px] "
                src={item.map}
                title="Harita"
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>

            <div className="md:w-[628px] bg-[white] p-5 md:p-10 text-firstColor rounded-lg">
              <p className="text-[24px] md:text-[28px] font-medium text-center">
                {t("Bizə Mesaj Göndər")}
              </p>
              <form className="mt-10" onSubmit={handleSubmit}>
                <p className="text-[14px] font-medium">{t("Ad/Soyad")}</p>
                <input
                  name="name"
                  className="rounded-lg h-[48px] w-full p-4 border-[1px] border-[#E2E2E2] mt-2 outline-none focus:ring-0 focus:outline-none"
                  placeholder="Type here"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />

                <p className="text-[14px] mt-6 font-medium">{t("Email")}</p>
                <input
                  name="email"
                  className="rounded-lg h-[48px] w-full p-4 border-[1px] border-[#E2E2E2] mt-2 outline-none focus:ring-0 focus:outline-none"
                  placeholder="Type here"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />

                <p className="text-[14px] mt-6 font-me">{t("Mesaj")}</p>
                <textarea
                  name="message"
                  className="rounded-lg w-full p-4 border-[1px] mt-2 h-[142px]  border-[#E2E2E2] outline-none focus:ring-0 focus:outline-none"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  placeholder={t("Mesajınızı daxil edin...")}
                />

                <button
                  type="submit"
                  className="w-full h-[44px] rounded-lg bg-[#181D27] text-white mt-6"
                >
                  {t("Göndər")}
                </button>

                {responseMessage.text && (
                  <p
                    className={`mt-4 text-center ${
                      responseMessage.isError
                        ? "text-red-500"
                        : "text-green-500"
                    }`}
                  >
                    {responseMessage.text}
                  </p>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;
